import React from "react";
import {
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

const LeadDetailSection = ({ leadDetails, fontSize }: any) => {
  const getTotalDistance = () => {
    const collectionAddresses = leadDetails?.lead?.collection_address || [];
    const deliveryAddresses = leadDetails?.lead?.delivery_address || [];

    const collectionDistance = collectionAddresses.reduce(
      (acc: number, curr: any) => acc + Number(curr.distance || 0),
      0
    );
    const deliveryDistance = deliveryAddresses.reduce(
      (acc: number, curr: any) => acc + Number(curr.distance || 0),
      0
    );
    const returningDistance = Number(
      leadDetails?.lead?.returning_distance || 0
    );

    return (collectionDistance + deliveryDistance + returningDistance).toFixed(
      2
    );
  };

  const { userProfile } = useSelector((state: any) => state?.user);

  return (
    <Accordion
      sx={{
        boxShadow: "none",
        border: "1px solid #C4CDD5",
        backgroundColor: "#E5F4F1",
        borderRadius: "5px",
        mb: 1,
        "&:before": { display: "none" },
        "&.Mui-expanded:last-of-type": {
          backgroundColor: "#E5F4F1",
          marginBottom: "10px",
          borderRadius: "5px",
        },
      }}
    >
      {/* ---- Accordion Header ---- */}
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          backgroundColor: "#E5F4F1",
          minHeight: "40px",
          borderRadius: "5px",
          "&.MuiAccordionSummary-root": {
            padding: "0 16px", // left-right only
            minHeight: "40px", // keep fixed height
          },
          "&.Mui-expanded": {
            minHeight: "40px", // same height when expanded
          },
          "& .MuiAccordionSummary-content": {
            margin: 0,
          },
          "& .MuiAccordionSummary-content.Mui-expanded": {
            margin: 0,
          },
        }}
      >
        <Typography variant="body2" sx={{ fontSize: fontSize || "14px" }}>
          Name: <b>{leadDetails?.lead?.customer_name || "N/A"}</b> • Total
          Distance: <b>{getTotalDistance()} Miles </b> • Lead ID:{" "}
          <b>{leadDetails?.lead?.generated_id || "N/A"}</b> • Email:{" "}
          <b>{leadDetails?.lead?.customer_email || "N/A"}</b> • Phone:{" "}
          <b>{leadDetails?.lead?.customer_country_code && leadDetails?.lead?.customer_phone
            ? `${leadDetails?.lead?.customer_country_code}${leadDetails?.lead?.customer_phone}`
            : leadDetails?.lead?.customer_phone ? leadDetails?.lead?.customer_phone : "N/A"}</b> • Move Date:{" "}
          <b>
            {leadDetails?.lead?.moving_on_date
              ? dayjs(leadDetails?.lead?.moving_on_date).format(
                  userProfile?.dateFormat ?? "DD/MM/YYYY"
                ) || "N/A"
              : "N/A"}
            {leadDetails?.lead?.moving_on_end_date
              ? ` - ${dayjs(leadDetails?.lead?.moving_on_end_date).format(
                  userProfile?.dateFormat ?? "DD/MM/YYYY"
                )}`
              : ""}
          </b>
          
        </Typography>
      </AccordionSummary>

      {/* ---- Accordion Content ---- */}
      <AccordionDetails
        sx={{
          fontSize: fontSize || "14px",
          paddingBottom: "8px",
          paddingTop: "0px",
        }}
      >
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6} sx={{ paddingLeft: "0px !important" }}>
            {leadDetails?.lead?.collection_address?.map(
              (address: any, index: any) => (
                <p style={{ marginBottom: "2px" }} key={index}>
                  Collection {index + 1}:{" "}
                  <strong>
                    {[
                      address?.building_number,
                      address?.street,
                      address?.town,
                      address?.county,
                      address?.country,
                      address?.postcode,
                    ]
                      .filter(Boolean) // remove null/undefined/empty strings
                      .join(", ")}
                    {
                      // Only add comma if at least one value exists
                      [
                        address?.building_number,
                        address?.street,
                        address?.town,
                        address?.county,
                        address?.country,
                        address?.postcode,
                      ].some(Boolean) && ", "
                    }
                  </strong>
                  <br />
                  <p style={{ marginTop: "2px" }}>
                    Bedrooms: <strong>{address?.house_size || "N/A"}</strong>{" "}
                    Distance:{" "}
                    <strong>{address?.distance?.toFixed(2) || "N/A"}</strong>{" "}
                    Volume: <strong>{address?.volume || "N/A"}{" "}{address?.volume ? address?.volume_unit : ""}</strong>
                  </p>
                </p>
              )
            )}
          </Grid>
          <Grid item xs={12} sm={6} sx={{ paddingLeft: "0px !important" }}>
            {leadDetails?.lead?.delivery_address?.map(
              (address: any, index: any) => (
                <p style={{ marginBottom: "2px" }} key={index}>
                  Delivery {index + 1}:{" "}
                  <strong>
                    {[
                      address?.building_number,
                      address?.street,
                      address?.town,
                      address?.county,
                      address?.country,
                      address?.postcode,
                    ]
                      .filter(Boolean) // remove null/undefined/empty strings
                      .join(", ")}
                    {
                      // Only add comma if at least one value exists
                      [
                        address?.building_number,
                        address?.street,
                        address?.town,
                        address?.county,
                        address?.country,
                        address?.postcode,
                      ].some(Boolean) && ", "
                    }
                  </strong>
                  {" "}<br />
                  <p style={{ marginTop: "2px" }}>
                    Bedrooms: <strong>{address?.house_size || "N/A"}</strong>{" "}
                  </p>
                </p>
              )
            )}
          </Grid>

          {/* <Grid
            item
            xs={12}
            sx={{ paddingLeft: "0px !important", paddingBottom: "0px" }}
          >
            Customer Notes:{" "}
            <strong>{leadDetails?.lead?.customer_notes || "N/A"}</strong>
          </Grid> */}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default LeadDetailSection;
